import { useState } from "react";
import { AxiosRequest } from "_services/api";

export function usePagarTaxa() {
  const msAw = AxiosRequest.makeApi(process.env.REACT_APP_MS_AW);

  const [pagando, setPagando] = useState(false);

  const pagarLote = async (
    idLote: number,
    idsProcessos: number[],
    confirmarPagamentoDebitosAdicionais = false,
  ) => {
    setPagando(true);
    try {
      const { data } = await msAw.post(
        `/financeiro/pagamento-taxa/lote/${idLote}/pagar`,
        { idsProcessos, confirmarPagamentoDebitosAdicionais },
      );
      return data;
    } finally {
      setPagando(false);
    }
  };

  return { pagando, pagarLote };
}
